// extracted by mini-css-extract-plugin
export default {"cell":"uioJj","content":"JDpta","today":"HOHpQ","active":"qUeOi","border":"ehDWz","withEvents":"zu0Js","day":"U4UuO","otherMonth":"gDogU"};